import { CommunicationChannelLabel } from '@scudraservicos/coordinator-client/dist/src/services/applications/interfaces/CommunicationChannel.types'

export const COMMUNICATION_CHANNEL_OPTIONS = [
  { label: 'SMS', type: CommunicationChannelLabel.SMS },
  { label: 'Whatsapp', type: CommunicationChannelLabel.WHATSAPP },
  { label: 'Chamada telefônica', type: CommunicationChannelLabel.PHONE_CALL },
]
